import React, { useEffect } from 'react'
import { PersonViewerInitialState, PersonViewerReducer, ACTIONS } from './PersonViewerReducer'

const PersonViewerStateContext = React.createContext()
const PersonViewerDispatchContext = React.createContext()

function PersonViewerProvider({ children }) {
  const [pvState, pvDispatch] = React.useReducer(PersonViewerReducer, PersonViewerInitialState)
  return (
    <PersonViewerStateContext.Provider value={pvState}>
      <PersonViewerDispatchContext.Provider value={pvDispatch}>{children}</PersonViewerDispatchContext.Provider>
    </PersonViewerStateContext.Provider>
  )
}

function usePersonViewerState() {
  const context = React.useContext(PersonViewerStateContext)
  if (context === undefined) {
    throw new Error('ERROR: usePersonViewerState must be used inside of PersonViewerProvider')
  }
  return context
}

function usePersonViewerDispatch() {
  const context = React.useContext(PersonViewerDispatchContext)
  if (context === undefined) {
    throw new Error('ERROR: usePersonViewerDispatch must be used inside of PersonViewerProvider')
  }
  return context
}

function usePersonViewerInitialization() {
  // use this hook only once to load required application data on page load
  const pvDispatch = usePersonViewerDispatch()
  const pvState = usePersonViewerState()

  useEffect(() => {
    if (!pvState.isLoading) {
      return
    }

    pvDispatch(
      {
        type: ACTIONS.INIT_PersonViewer,
        data: {
          lockMemories: false,
        },
      },
      []
    )
  })
}

export { PersonViewerProvider, usePersonViewerState, usePersonViewerInitialization, usePersonViewerDispatch, ACTIONS }
